import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PurchasePlusPageInfoFragmentDoc } from './PageInfo.generated'
import * as Types from './purchasePlus_graphql'

export const GetCatAndSubCatCategoriesDocument = gql`
  query GetCatAndSubCatCategories(
    $after: String
    $before: String
    $filters: CategoriesQueryFiltersInput
    $first: Int
    $last: Int
    $sorts: [CategoriesQuerySortsInput!]
  ) {
    categories(after: $after, before: $before, filters: $filters, first: $first, last: $last, sorts: $sorts) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        ...PurchasePlusPageInfo
      }
    }
  }
  ${PurchasePlusPageInfoFragmentDoc}
` as unknown as DocumentNode<Types.GetCatAndSubCatCategoriesQuery, Types.GetCatAndSubCatCategoriesQueryVariables>
